export const MAX_LENGTH_TAG = 50; // tags, very short labels
export const MAX_LENGTH_SHORT_LABEL = 255; // names, codes, short identifiers
export const MAX_LENGTH_TITLE = 255; // titles, portal/org names
export const MAX_LENGTH_DESCRIPTION = 5000; // notes, free-text, translations
export const MAX_LENGTH_EMAIL_BODY = 10000;
export const MAX_LENGTH_EMAIL = 254;
export const MAX_LENGTH_URL = 2048;
export const MAX_LENGTH_PASSWORD = 128;
